import React from "react";
import styled from "styled-components";
import { Theme } from "../../themes/theme";

const Wrapper = styled.p`
  color: ${Theme.color.text.neutral};
  font-size: ${Theme.font.fontSize.base};
  line-height: ${Theme.font.lineHeight.relaxed};
  margin: 0;
`;

function Description({ children }) {
  return <Wrapper>{children}</Wrapper>;
}

export default Description;
